// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33u9H","icon":"styles_icon__273DF"};